import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import {
  RecordData,
  RecordTableColumnParams,
  RecordTotalData
} from "../../../../../types/records-table.types";
import {
  advertisementPackagesResourceType,
  defaultRecordsAdvertisementPackagesParams
} from '../../configs/advertisement-packages-modal.config';
import {RecordsAdvertisementPackagesService} from "../../services/records-advertisement-packages.service";
import {AdvertisementPackagesModalService} from "../../services/advertisement-packages-modal.service";
import {Pageable} from "../../../../../types/pagable.types";
import {defaultPaginationData} from "../../../repeats-modal/configs/repeats-table.config";
import {defaultRecordTableParams} from "../../../../../models/default-record-table-params";
import {DetachProps} from "../../../../../types/attach-detach.types";
import {RecordsAdvertisementPackagesParams} from "../../types/advertisement-packages-modal.types";
import {RecordTableAction} from "../../../../../types/record-table-action.types";
import {ActionDropdownMenuComponent} from "../../../../action-dropdown-menu/action-dropdown-menu.component";
import {RecordsTableViewComponent} from "../../../../records-table-view/records-table-view.component";
import {MatButton} from "@angular/material/button";
import {CloseModalReason} from "../../../../../types/modal.types";

@Component({
  selector: 'app-records-advertisement-packages',
  standalone: true,
  imports: [
    ActionDropdownMenuComponent,
    RecordsTableViewComponent,
    MatButton
  ],
  templateUrl: './records-advertisement-packages.component.html',
  styleUrl: './records-advertisement-packages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordsAdvertisementPackagesComponent implements OnInit {
  recordsAdvertisementPackagesParams = input<RecordsAdvertisementPackagesParams>(defaultRecordsAdvertisementPackagesParams);
  onCloseDialog = output<CloseModalReason>();
  handleDetachData = output<DetachProps>();
  handleSetLoadingState = output<boolean>();

  private recordsAdvertisementPackagesService: RecordsAdvertisementPackagesService = inject(RecordsAdvertisementPackagesService);
  private advertisementPackagesModalService: AdvertisementPackagesModalService = inject(AdvertisementPackagesModalService);


  public readonly advertisementPackagesResourceType = advertisementPackagesResourceType;
  public recordTableParams: Array<RecordTableColumnParams> = [];
  public tableActions: Array<RecordTableAction> = []
  public recordsData: Pageable<RecordData> | null = null;
  public recordsTotalData: Array<RecordTotalData> = [];

  public async ngOnInit() {
    this.handleSetLoadingState.emit(true);
    await this.getRecordsTableParams();
    await this.getRecordsData();
    await this.getAggregations();
    this.handleSetLoadingState.emit(false);
  }

  public unbindAdvertisementPackage(): void {
    const detachProps: DetachProps = {
      path: advertisementPackagesResourceType.path,
      recordCalendarId: this.recordsAdvertisementPackagesParams().recordCalendarId
    };

    this.handleDetachData.emit(detachProps);
  }

  private async getRecordsTableParams() {
    const recordsTableParams = await this.recordsAdvertisementPackagesService.getRecordsTableParams().catch(() => {
      this.onCloseDialog.emit('cancel');
      return defaultRecordTableParams;
    });

    this.recordTableParams = this.recordsAdvertisementPackagesService.getRecordTableColumnParams(recordsTableParams);
    this.tableActions = recordsTableParams.actions;
  }

  private async getAggregations() {
    this.recordsTotalData = await this.advertisementPackagesModalService.getAggregations(this.recordsAdvertisementPackagesParams().advertisementPackageId)
      .catch(() => []);
  }

  private async getRecordsData() {
    const data = await this.advertisementPackagesModalService.getRecordsData(this.recordsAdvertisementPackagesParams().advertisementPackageId)
      .catch(() => []);

    this.recordsData = {
      content: data,
      ...defaultPaginationData
    };
  }
}
